<ng-container *adaptLoading="!isInitialised">
    <div class="outer-quarter-circle"
         [ngClass]="cornerClass"></div>
    <div class="quarter-circle"
         [ngClass]="cornerClass">
        <div class="good-at"
             [ngClass]="cornerClass"></div>
        <div class="bullseye-part"
             [ngClass]="bullseyeClasses">
            <div class="bullseye-target-dot"
                 [ngClass]="cornerClass"></div>
        </div>
    </div>
    @if (arcPath) {
        <svg xmlns="http://www.w3.org/2000/svg"
             class="overlay-svg">
            <!-- <path id="arc"
    d="M300,0 A300,300 0 0,0 0,300"></path> -->
            <path [attr.id]="arcId"
                  class="quadrant-arc"
                  [attr.d]="arcPath"></path>
            <text class="quadrant-text">
                <textPath [attr.xlink:href]="arcIdRef"
                          [attr.startOffset]="startOffset">
                    {{ quadrantText }}
                </textPath>
            </text>
        </svg>
    }
    @if (!hideOuter) {
        <div class="text-container-outer">
            @for (statement of statements; track statement) {
                <div class="statement-text"
                     [ngClass]="{
                        'statement-text-in-edit': isEditing || isSelecting,
                        'statement-selected': isStatementSelected(statement),
                    }"
                     (click)="onStatementClicked(statement)"
                     [adaptTooltip]="statement.statement">
                    {{ statement.statement }}
                </div>
            }
        </div>
    }
    <div class="text-container-inner">
        @for (statement of inBullseyeStatements; track statement) {
            <div class="statement-text-in-bullseye"
                 [ngClass]="{
                    'statement-text-in-edit': isEditing || isSelecting,
                    'statement-selected': isStatementSelected(statement),
                }"
                 (click)="onStatementClicked(statement)"
                 [adaptTooltip]="statement.statement">
                {{ statement.statement }}
            </div>
        }
    </div>
</ng-container>
